import React, { useState } from 'react';
import Button from '../../../components/ui/Button';


const AlternativeAuth = () => {
  const [showQRCode, setShowQRCode] = useState(false);

  const handleQRCodeAccess = () => {
    setShowQRCode(!showQRCode);
  };

  return (
    <div className="space-y-6">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-background text-muted-foreground">
            Alternative access methods
          </span>
        </div>
      </div>
      <div className="space-y-4">
        <Button
          variant="outline"
          size="lg"
          fullWidth
          onClick={handleQRCodeAccess}
          iconName="QrCode"
          iconPosition="left"
        >
          {showQRCode ? 'Hide QR Code' : 'Access via QR Code'}
        </Button>

        {showQRCode && (
          <div className="p-6 bg-muted rounded-lg text-center">
            <div className="w-32 h-32 mx-auto mb-4 bg-white border-2 border-border rounded-lg flex items-center justify-center">
              <div className="w-24 h-24 bg-gradient-to-br from-primary to-accent rounded grid grid-cols-8 gap-px p-2">
                {Array.from({ length: 64 })?.map((_, i) => (
                  <div
                    key={i}
                    className={`rounded-sm ${
                      Math.random() > 0.5 ? 'bg-white' : 'bg-transparent'
                    }`}
                  />
                ))}
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-2">
              Scan with your mobile device
            </p>
            <p className="text-xs text-muted-foreground">
              Use your organization's mobile app to scan this QR code for quick access
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AlternativeAuth;